export default class BackInStockPopup {
  constructor(component) {
    this.dom = {
      $component: component,
      $closePopUp: document.querySelectorAll('.js-bisPopUpClose'),
      $underlay: document.querySelector('.js-bisPopUpUnderlay'),
      $title: component.querySelector('.js-bisProductTitle'),
      $optionsContainer: component.querySelector('.js-bisOptionContainer'),
      $input: component.querySelector('.js-bisEmail'),
      $productId: component.querySelector('.js-bisProductId'),
      $variantId: component.querySelector('.js-bisVariantId'),
      $form: component.querySelector('.js-bisForm'),
      $responseMessage: component.querySelector('.js-responseMessage')
    }
    this.state = {
      open: false,
      openPopUpClass: 'openPopUp',
      activeUnderlayClass: 'isActive',
      singleOptionClass: 'singleOption',
      showSuccessClass: 'success',
      showErrorClass: 'error'
    }
    this.closePopUpHandler = this.closePopUp.bind(this)
    this.submitHandler = this.submit.bind(this)
    this.setProductInfoHandler = this.setProductInfo.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const {dom} = this
    dom.$closePopUp.forEach($toggle => $toggle.addEventListener('click', this.closePopUpHandler))
    dom.$form.addEventListener('submit', this.submitHandler)
    document.addEventListener('bistrigger', this.setProductInfoHandler)
  }

  setProductInfo({detail}) {
    const {dom, state} = this
    dom.$title.textContent = detail.productTitle
    dom.$productId.value = detail.productId
    dom.$variantId.value = detail.variantId

    if (detail.color) {
      const colorOption = document.createElement('div')
      colorOption.className = 'BackInStockPopup__option'
      colorOption.innerHTML = `
        <span class="Swatch bisPopUp">
          <span
            class="Swatch__inset productSwatch"
            data-color="${detail.color.toLowerCase().replace(' ', '-')}"
          ></span>
        </span>
        <span class="rmp-small">
          ${detail.color}
        </span>
      `
      dom.$optionsContainer.append(colorOption)
    }

    if (detail.size) {
      const sizeOption = document.createElement('div')
      sizeOption.className = 'BackInStockPopup__option'
      sizeOption.innerHTML = `
        <span class="rmp-small">
          Size ${detail.size}
        </span>
      `
      dom.$optionsContainer.append(sizeOption)
    }

    if (!(detail.size && detail.color)) {
      dom.$optionsContainer.classList.add(state.singleOptionClass)
    }

    this.openPopUp()
  }

  openPopUp() {
    const {dom, state} = this
    dom.$component.setAttribute('aria-hidden', 'false')
    dom.$component.setAttribute('aria-expanded', 'true')
    dom.$component.classList.add(state.openPopUpClass)
    dom.$underlay.classList.add(state.activeUnderlayClass)
    state.open = true
  }

  closePopUp() {
    const {dom, state} = this
    dom.$component.setAttribute('aria-hidden', 'true')
    dom.$component.setAttribute('aria-expanded', 'false')
    dom.$component.classList.remove(state.openPopUpClass)
    dom.$underlay.classList.remove(state.activeUnderlayClass)
    dom.$title.textContent = ''
    dom.$productId.value = ''
    dom.$variantId.value = ''
    dom.$optionsContainer.innerHTML = ''
    dom.$responseMessage.innerHTML = ''
    dom.$responseMessage.classList.remove(state.showSuccessClass)
    dom.$responseMessage.classList.remove(state.showErrorClass)
    dom.$optionsContainer.classList.remove(state.singleOptionClass)
    state.open = false
  }

  async submit(e) {
    e.preventDefault()
    const {dom, state} = this
    const id = parseInt(dom.$productId.value)
    const variantId = parseInt(dom.$variantId.value)
    const email = dom.$input.value

    try {
      const response = await BIS.create(email, variantId, id)

      if (response.status == 'OK') {
        dom.$responseMessage.textContent = response.message
        dom.$responseMessage.classList.add(state.showSuccessClass)
      } else if (response.errors) {
        const errorMessage = Object.values(response.errors)
        .map(errorArr => errorArr.join('<br>'))
        .join('<br>')
        dom.$responseMessage.innerHTML = errorMessage
        dom.$responseMessage.classList.add(state.showErrorClass)
      }

    } catch(e) {
      console.log('Error submitting BIS notification', e)
    }
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.BackInStockPopup = this
  }
}
